var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mismatchLossCheck } from "./utils/mismatchLoss";
import { severeHearingLossCheck } from "./utils/severeHearingLoss";
import { calcuatePureToneAverage } from "./utils/calculatePureToneAverage";
/**
 * List of supported device model ids
 * @constant
 * @default default ['6144007', '540938247', '72780372515670', '72986808818502']
 */
export var deviceModelIds = ['6144007', '540938247', '72780372515670', '72986808818502'];
/**
 * Gets the cluster file for a specific device model id
 *
 * @param deviceModelId Input model id for the hearing device
 * @returns Returns the recommended cluster for the device
 */
export function getClusterFile(deviceModelId) {
    if (!deviceModelIds.includes(deviceModelId)) {
        console.error("\nError: The Recommendation Engine file for device ".concat(deviceModelId, " is not available."));
        return null;
    }
    try {
        return require("./OTC_Tool_RecommendationEnginePreprocessor_Output/".concat(deviceModelId, "_Cluster_File.json"));
    }
    catch (error) {
        console.error("Module not found: ".concat(error.message));
        return null;
    }
}
/**
 * Returns the recommended cluster for a monaural audiogram
 *
 * @param deviceModelId Input model id for the hearing device
 * @param audiogram Input monaural audiogram for the hearing device
 * @returns Returns the recommended cluster for the device
 */
export function getRecommendedClusterMonaural(deviceModelId, audiogram) {
    var audiogramfreq1 = audiogram[0], audiogramfreq2 = audiogram[1], audiogramfreq3 = audiogram[2], audiogramfreq4 = audiogram[3];
    var clusterData = getClusterFile(deviceModelId);
    if (clusterData == null)
        return null;
    var audiogramKey = "".concat(audiogramfreq1, " ").concat(audiogramfreq2, " ").concat(audiogramfreq3, " ").concat(audiogramfreq4);
    if (clusterData[audiogramKey] == null) {
        console.error("\nERROR: Could not find a recommended cluster, please check that your audiogram values are valid. (25dB - 85dB)\n");
        return null;
    }
    else {
        var pureToneAverage = calcuatePureToneAverage(audiogram);
        var cluster = clusterData[audiogramKey];
        var result = __assign(__assign({}, cluster), { PureToneAverage: pureToneAverage });
        return result;
    }
}
/**
 * Returns the recommended cluster for a binaural audiogram
 *
 * @param deviceModelId Input model id for the hearing device
 * @param audiograms Input binaural audiograms for the hearing device
 * @returns Returns the recommended cluster for the device
 */
export function getRecommendedClusterBinaural(deviceModelId, audiograms) {
    var leftCluster = getRecommendedClusterMonaural(deviceModelId, audiograms["Left"]);
    var rightCluster = getRecommendedClusterMonaural(deviceModelId, audiograms["Right"]);
    if (leftCluster == null || rightCluster == null) {
        console.error("\nERROR: Could not find recommended clusters, please check that your audiogram values are valid. (25dB - 85dB)\n");
        return null;
    }
    var isSevereHearingLoss = severeHearingLossCheck(deviceModelId, audiograms);
    var isMismatchLoss = mismatchLossCheck(deviceModelId, audiograms);
    return {
        Left: leftCluster,
        Right: rightCluster,
        isSevereHearingLoss: isSevereHearingLoss,
        isMismatchLoss: isMismatchLoss,
    };
}
export default {
    getClusterFile: getClusterFile,
    getRecommendedClusterBinaural: getRecommendedClusterBinaural,
    getRecommendedClusterMonaural: getRecommendedClusterMonaural
};
